import React from 'react';
import {Field, reduxForm} from "redux-form";
import {email, password, phoneNumber, required} from "../validators";
import WrapWithLoader from "./WrapWithLoader";


const renderTextInput = (field) => {
  return (
    <div className="form-group">
      <label>{field.label}</label>
      <input {...field.input} placeholder={field.placeholder} className="form-control" type={field.type}/>
      {field.meta.touched && field.meta.error &&
      <small className="error form-text">{field.meta.error}</small>}
    </div>
  );
};

const renderPasswordInput = (field) => {
  return (
    <div className="form-group">
      <label>{field.label}</label>
      <input {...field.input} placeholder={field.placeholder} className="form-control" type={field.type}/>
      <small className="error form-text">
        {(field.meta.error && field.meta.touched) && field.meta.error}
      </small>
    </div>
  );
};


function BusinessSignUpForm(props) {
  const {submitting, valid, handleSubmit} = props;

  return (
    <form className="sign-up-form" onSubmit={handleSubmit}>
      {/* Account Info */}
      <div className="form-section">
        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <h4>Contact Information</h4>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <Field component={renderTextInput}
                     label={"Name"}
                     type="text"
                     name="name"
                     validate={[required]}
                     className="form-control"/>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <label>Phone Number</label>
              <div className="form-inline">
                <Field component="select"
                       validate={[required]}
                       className="custom-select countryCode" name="countryCode">
                  <option>+65</option>
                  <option>+60</option>
                </Field>
                <Field component="input" type="tel"
                       name="phoneNumber"
                       validate={[required, phoneNumber]}
                       className="form-control phoneNumber"/>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <Field component={renderTextInput}
                     label={"Email"}
                     type="email"
                     name="email"
                     validate={[required, email]}
                     className="form-control"/>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <Field component={renderPasswordInput}
                     label={"Password"}
                     type="password"
                     name="password"
                     validate={[required, password]}
                     className="form-control"/>
            </div>
          </div>
        </div>

      </div>

      {/* Business */}
      <div className="form-section">
        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <h4>Business Information</h4>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <Field type="text"
                     component={renderTextInput}
                     validate={[required]}
                     label={"Name"}
                     name="businessName"
                     className="form-control"/>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <label>Type</label>
              <Field name="businessType"
                     component="select"
                     validate={[required]}
                     className="form-control custom-select">
                <option>Restaurant</option>
                <option>Catering</option>
                <option>Bar</option>
                <option>Other</option>
              </Field>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <Field name="businessAddress"
                     label='Address'
                     placeholder='e.g. City Hall (15 Beach Rd, 189677)'
                     component={renderTextInput}
                     validate={[required]}
                     className="form-control"/>
            </div>
          </div>
        </div>

      </div>

      {/* Submit */}
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-6">
          <WrapWithLoader loading={submitting}>
            <button id="submit"
                    className="btn btn-primary btn-xlg btn-block btn-pointer"
                    disabled={submitting || !valid}
                    type="submit">
              Create Account
            </button>
          </WrapWithLoader>
        </div>
      </div>
    </form>
  )
}


export default reduxForm({
  form: 'businessSignUpForm',
  initialValues: {
    countryCode: '+65',
    businessType: 'Restaurant',
  },
})(BusinessSignUpForm);



// WEBPACK FOOTER //
// ./src/parts/BusinessSignUpForm.js